import { inject } from '@angular/core';
import { CanActivateFn, Router, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';

import { NetworkStatusService } from '../services/network-status.service';

export const isOnlineGuard: CanActivateFn = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | UrlTree => {
  const networkStatusService = inject(NetworkStatusService);
  const router = inject(Router);

  const isOnline = networkStatusService.isOnline();
  const currentUrl = state.url.replace(/\/+$/, '') || '/';

  const isOfflineRoute = currentUrl.startsWith('/offline/');

  if (isOnline && isOfflineRoute) {
    const newUrl = currentUrl.replace(/^\/offline/, '');
    return router.parseUrl(newUrl || '/');
  }

  if (!isOnline && !isOfflineRoute) {
    const offlineUrl = currentUrl === '/' ? '/offline' : '/offline' + currentUrl;
    return router.parseUrl(offlineUrl);
  }

  return true;
};
